// extracted by mini-css-extract-plugin
export default {"loading":"photoExhibition_loading__WPESz","pcWrap":"photoExhibition_pcWrap__jPoxJ"};